import { useLayoutEffect, useState } from 'react'
import { useEvent } from './useEvent'

export const useNumberTransition = (
  current: number,
  durationS: number,
  onTransitionEnd?: () => void,
  delayS: number = 0,
) => {
  const [smoothedNumber, setSmoothedNumber] = useState(current)
  const onTransitionEndEvent = useEvent(onTransitionEnd)

  useLayoutEffect(() => {
    if (durationS === 0) {
      setSmoothedNumber(current)
    } else {
      let id = 0
      const startTime = Date.now()
      const currentDuration = durationS * 1000
      const currentDelay = delayS * 1000
      const initialValue = smoothedNumber
      const targetValue = current
      const tick = () => {
        const currentTime = Date.now()
        const diff = currentTime - startTime
        const progress =
          diff < currentDelay
            ? 0
            : Math.min(1, (diff - currentDelay) / currentDuration)
        if (progress === 1) {
          onTransitionEndEvent()
          setSmoothedNumber(current)
        } else {
          setSmoothedNumber(
            initialValue + (targetValue - initialValue) * progress,
          )
          id = requestAnimationFrame(tick)
        }
      }
      id = requestAnimationFrame(tick)
      return () => {
        cancelAnimationFrame(id)
      }
    }
    // miss smoothedNumber intentionally
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current, durationS, onTransitionEndEvent])

  return smoothedNumber
}
